import store from "@/store";

import { _updateData } from "@/api/esdata";
import { ipValidate } from "@/api/formValidate";
import { checkDocumentExist } from "@/api/documentexist";
import { getFormOptions } from "@/api/formoptions";
import { removeFromGroup } from "@/api/slb";

const isAdmin = store.state.userData.privilege == "admin";

export const settingZoneExplain = (parentVue) => {
    return {
        description:
            "<p>The <strong>Slb</strong> is where your client will access from there browser, the closer your slb with your client, the better browsing exprience they will have. If you create Slb manually, it will be marked as <strong>virtual</strong>, so it's recommended to name it recognizable.</p>",
    };
};

export const groupName = (parentVue) => {
    return {
        // formRender: "FormInput",
        multiple: true,
        withForm: true,
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;
            return h("TagList", {
                props: {
                    listData: params.row.groupName,
                    maxShow: "5",
                    title: vm.$i18n.t("slbsetting.groupName"),
                    width: "350",
                },
            });
        },
        watchField: function (value, item) {},
        defaultVal: parentVue.$store.state.queryGroupName == "all" ? [] : [parentVue.$store.state.queryGroupName],
        validate: [
            {
                validator: (rule, value, callback, source, options) => {
                    if (parentVue.$refs.rcmTable.formData.serviceProvideType == "normal" && value.length > 1)
                        return callback(new Error("最多只能填一個"));
                    callback();
                },
                trigger: "blur",
            },
        ],
    };
};
export const serviceIP = (parentVue) => {
    return {
        sectionKey: "essential",
        formTypes: ["createForm", "editForm"],
        validate: [
            {
                validator: (rule, value, callback) => {
                    var vm = parentVue.$refs.rcmTable;
                    if (value) return callback();
                    if (vm.formData.recordType == "A" && !vm.formData.serviceIPv6) {
                        return callback(new Error(vm.$i18n.t("slbsetting.atLeastOneServiceIPRequired")));
                    }
                    if (vm.formData.recordType === "CNAME") {
                        return callback(
                            new Error(`${vm.$i18n.t("slbsetting.serviceIP")}${vm.$i18n.t("rcmtable.validateEmptyText")}`)
                        );
                    }
                    callback();
                },
                trigger: "blur",
            },
            {
                validator: (rule, value, callback, source, options) => {
                    var vm = parentVue.$refs.rcmTable;
                    if (!value) return callback();
                    if (vm.formData.recordType == "A") {
                        ipValidate("serviceip", value).then((result) => {
                            if (!result.data.success) {
                                return callback(new Error(result.data.message));
                            }
                            callback();
                        });
                    } else if (vm.formData.recordType == "CNAME") {
                        ipValidate("validCname", value).then((result) => {
                            if (!result.data.success) {
                                return callback(new Error(result.data.message));
                            }
                            callback();
                        });
                    }
                },
                trigger: "blur",
            },
        ],
        // 服務地址（IPv6）未填時，這欄的輸入會影響「至少填一項」的提示，連動重驗另一欄
        watchField: (value, formData) => {
            var vm = parentVue.$refs.rcmTable;
            if (formData.recordType !== "A" || formData.serviceIPv6) return;
            vm.$nextTick(() => {
                if (vm.$refs.form && typeof vm.$refs.form.validateField === "function") {
                    vm.$refs.form.validateField("serviceIPv6");
                }
            });
        },
        // 普通用戶無法調整防禦節點IP
        disabled: () => parentVue.$refs.rcmTable.formData.serviceProvideType == "protect" && !isAdmin,
    };
};
export const isEnabled = (parentVue) => {
    return {
        sectionKey: "essential",
        render: (h, params) => {
            var status = params.row.isenabled;
            var vm = parentVue.$refs.rcmTable;
            return h("i-switch", {
                props: {
                    value: status,
                    beforeChange() {
                        return new Promise((resolve) => {
                            vm.$Modal.confirm({
                                title: vm.$i18n.t("rcmtable.changeStatusText"),
                                content: vm.$i18n.t("rcmtable.confirmChangeStatusText"),
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    resolve();
                                },
                            });
                        });
                    },
                    disabled: vm.isEditBtnDisabled,
                },
                on: {
                    "on-change": (value) => {
                        params.row.isenabled = value;
                        delete params.row._index;
                        delete params.row._rowKey;
                        delete params.row._checked;
                        _updateData("rcm-slbs", "index", params.row)
                            .then((result) => {
                                vm.$Notice.success({
                                    title: vm.$i18n.t("global.success"),
                                    desc: `${result.data.message}`,
                                });
                            })
                            .catch(function (error) {
                                vm.$Notice.warning({
                                    title: vm.$i18n.t("global.error"),
                                    desc: `${error}`,
                                });
                                vm.getTableData();
                            });
                    },
                },
            });
        },
    };
};
export const hostName = (parentVue) => {
    return {
        sectionKey: "essential",
        render: (h, params) => {
            const p = h("p", params.row.hostname);

            const virtualTag = h("Tag", {}, "virtual");

            const normalTag = h("Tag", {}, "normal");
            const protectTag = h("Tag", {}, "protect");

            const elements = [p];
            elements.push(virtualTag);
            elements.push(params.row.serviceProvideType == "protect" ? protectTag : normalTag);
            return h("span", {}, elements);
        },
        validate: [
            {
                required: true,
                message: `${parentVue.$i18n.t("slbsetting.hostname")} ${parentVue.$i18n.t(
                    "rcmtable.validateEmptyText"
                )}`,
                trigger: "blur",
            },
            {
                validator: (rule, value, callback, source, options) => {
                    var vm = parentVue.$refs.rcmTable;
                    if (!/^[a-z0-9\-\_]*$/.test(value))
                        return callback(new Error(`${vm.$i18n.t("rcmtable.validateIllegalCharsPrefix")}: a-z 0-9 - _`));
                    if (value.length > 35)
                        return callback(new Error(`${vm.$i18n.t("rcmtable.validateExceedLengthPrefix")}: 35`));
                    checkDocumentExist({
                        topic: "slbHostname",
                        fieldVal: value,
                        groupName: vm.formData.groupName,
                    }).then((result) => {
                        if (!result.data.success) {
                            return callback(new Error(`${value} ${vm.$i18n.t("rcmtable.validateExistText")}`));
                        }
                        callback();
                    });
                },
                trigger: "blur",
            },
        ],
    };
};

export const line = (parentVue) => {
    return {
        withOptionGroup: true,
        remoteOptions: async (queryValue, queryParams) => {
            var vm = parentVue.$refs.rcmTable;
            queryValue = queryValue || "*";
            queryParams.lineName = `*${queryValue}*`;
            if (vm.formData.groupName && vm.formData.groupName.length > 0) {
                queryParams.groupNames = vm.formData.groupName;
            } else {
                queryParams.groupName = "";
            }
            queryParams.optionGrouping = true;
            queryParams.withRecordLineGroups = true;
            let queryString = new URLSearchParams(queryParams).toString();
            let result = await getFormOptions(`/recordlinenames?${queryString}`);
            return result.data.options;
        },
    };
};

export const action = (parentVue) => {
    return {
        width: 160,
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;

            const actionDivArray = [];
            const editBtn = h("Button", {
                props: {
                    shape: "circle",
                    icon: vm.isEditBtnDisabled ? "md-eye" : "md-create",
                },
                on: {
                    click: () => {
                        vm.editItem(params.row);
                    },
                },
            });
            var dropdownItems = [];
            if (store.getters.isInAllGroupView) {
                dropdownItems.push({
                    value: "delete",
                    title: vm.$t("rcmtable.deleteText"),
                    modalTitle: vm.$t("rcmtable.deleteText"),
                    modalContent: vm.$t("rcmtable.confirmDeleteText"),
                    disabled: vm.isDeleteBtnDisabled,
                });
            } else {
                dropdownItems.push({
                    value: "removeFromGroup",
                    title: vm.$i18n.t("slbsetting.removeFromGroup"),
                    modalTitle: vm.$i18n.t("slbsetting.removeFromGroup"),
                    modalContent: vm.$i18n.t("slbsetting.removeFromGroupText"),
                    disabled: vm.isEditBtnDisabled,
                });
            }

            const moreBtn = h(
                "Dropdown",
                {
                    props: {
                        trigger: "click",
                        placement: "right",
                        transfer: true,
                    },
                    on: {
                        "on-click": (value) => {
                            var currentItem = dropdownItems.find((e) => e.value == value);
                            vm.$Modal.confirm({
                                title: currentItem.modalTitle,
                                content: currentItem.modalContent,
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    if (value == "delete") {
                                        var deleteItem = Object.assign({}, params.row);
                                        delete deleteItem._index;
                                        delete deleteItem._rowKey;

                                        vm.actionType = "delete";
                                        vm.updateData(vm.esIndex, "delete", deleteItem);
                                    } else if (value == "removeFromGroup") {
                                        removeFromGroup({
                                            nodeId: params.row.nodeId,
                                            groupName: vm.$store.state.queryGroupName,
                                        });
                                    } else {
                                        currentItem
                                            .apiAction(params.row)
                                            .then((result) => {
                                                vm.$Notice.success({
                                                    title: vm.$i18n.t("global.success"),
                                                    desc: `${result.data.message}`,
                                                });
                                            })
                                            .catch(function (error) {
                                                vm.$Notice.warning({
                                                    title: vm.$i18n.t("global.error"),
                                                    desc: `${error}`,
                                                });
                                                // vm.getAllData();
                                            });
                                    }
                                },
                            });
                        },
                    },
                },
                [
                    h("a", [
                        h("Button", {
                            props: {
                                shape: "circle",
                                icon: "md-more",
                                key: params.index,
                            },
                        }),
                    ]),
                    h(
                        "DropdownMenu",
                        {
                            slot: "list",
                        },
                        [
                            dropdownItems.map(function (item) {
                                return h(
                                    "DropdownItem",
                                    {
                                        props: {
                                            name: item.value,
                                            disabled: item.disabled,
                                        },
                                    },
                                    item.title
                                );
                            }),
                        ]
                    ),
                ]
            );
            if (vm.userCanIndex) {
                actionDivArray.push(editBtn);
            }
            actionDivArray.push(moreBtn);
            return h("div", actionDivArray);
        },
    };
};



// WEBPACK FOOTER //
// ./src/view/VirtualSlbSetting/fields.js